import { postMessageId, chikiiWebUrlWww, chikiiWebUrl } from "@/config";

// cookies.setCookie('a','b', 5 * 1000)键，值，时间（5秒）
export const cookies = {
  setCookie: function (name: string, value: unknown, ms: number) {
    let expires = "";
    if (ms) {
      const date = new Date();
      date.setTime(date.getTime() + ms);
      // toGMTString 方法已废弃
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  },

  getCookie: function (name: string) {
    if (0 < document.cookie.length) {
      const k = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]*)(;|$)")
      );
      return k === null ? "" : k[2];
    }
    return null;
  },
};

const iframe = document.getElementById(postMessageId);
const isIframe = (el: HTMLElement | null): el is HTMLIFrameElement => {
  return el !== null && el.tagName === "IFRAME";
};
const hasWWW = /www/i.test(window.location.host);

enum EStorageType {
  ls = 0,
  ss = 1,
}
export const localCache = {
  ss: window.sessionStorage,
  ls: window.localStorage,

  getItem(key: string, type: EStorageType = 0) {
    const data = this[type ? "ls" : "ss"].getItem(key);
    if (data === null) {
      return data;
    }
    return JSON.parse(data);
  },
  setItem(key: string, val: unknown, type: EStorageType = 0) {
    this[type ? "ls" : "ss"].setItem(key, JSON.stringify(val));

    if (iframe && isIframe(iframe) && iframe.contentWindow) {
      iframe.contentWindow.postMessage(
        {
          action: "SET_ITEM",
          payload: {
            key,
            val: JSON.stringify(val),
            type,
          },
        },
        hasWWW ? chikiiWebUrl : chikiiWebUrlWww
      );
    }
    return this;
  },
  clear(type = 0) {
    this[type ? "ls" : "ss"].clear();
  },
  keys(type = 0) {
    return this[type ? "ls" : "ss"].keys();
  },
  removeItem(key: string, type = 0) {
    const data = this.getItem(key);
    this[type ? "ls" : "ss"].removeItem(key);
    return data;
  },
};
